const sportsContent = {
  "sports-id": {
    title: "Sports Medicine",
    sections: [
      {
        type: "text",
        content: `
          <h4 class="kneePartsTitle">Sports Medicine</h4>

          <p>
            Sports medicine focuses on improving physical fitness and treating injuries related 
            to sports and regular exercise. It helps athletes, fitness enthusiasts, and even 
            non-sportspersons recover from injuries and return safely to daily activity or sport.
          </p>

          <h4 class="kneePartsTitle">It Includes:</h4>
          <ul>
            <li>Physical fitness</li>
            <li>Treatment and prevention of injuries related to sports and exercise</li>
          </ul>

          <h4 class="kneePartsTitle">Common Sports Injuries</h4>
          <p>Commonly seen injuries include sprain, concussion, ligament injuries, cartilage damage and joint fractures.</p>

          <p><strong>Most commonly involved joints:</strong></p>
          <ul>
            <li>Knee</li>
            <li>Shoulder</li>
            <li>Ankle</li>
            <li>Elbow</li>
            <li>Wrist</li>
          </ul>

          <p>
            The pattern of injury depends on the sport type and nature of trauma. Each injury 
            requires proper evaluation to help prevent long-term damage.
          </p>

          <h4 class="kneePartsTitle">Prevention</h4>
          <ul>
            <li>Nutritious healthy diet</li>
            <li>Strengthening exercises</li>
          </ul>

          <h4 class="kneePartsTitle">Management</h4>
          <p>
            Treatment depends on the severity and type of injury.  
          </p>
          <ul>
            <li>Non-surgical management includes analgesics, anti-inflammatory medicines, and physiotherapy</li>
            <li>Certain cases may require surgical intervention for complete recovery</li>
          </ul>

          <p>
            Early diagnosis improves long-term outcomes and helps athletes return to sport safely.  
            Talk to <a href="/" class="DrSachinName">Dr. Sachin Karkamkar</a>, Hadapsar, Punefor complete evaluation.
          </p>
        `
      }
    ]
  }
};

export default sportsContent;
